import type { Exchanger } from "../exchanger";
import type { User } from "../profile";
import type { Trade, TradeType } from "../trade";

export const ReviewRole = {
  BUYER: "BUYER",
  SELLER: "SELLER",
} as const;

export type ReviewRole = (typeof ReviewRole)[keyof typeof ReviewRole];

export const ReviewType = {
  POSITIVE: "POSITIVE",
  NEGATIVE: "NEGATIVE",
} as const;

export type ReviewType = (typeof ReviewType)[keyof typeof ReviewType];

export interface Review {
  id: string;
  userId: string;
  user?: User;
  exchangerId?: string | null;
  exchanger?: Exchanger | null;
  targetUserId: string;
  tradeId?: string | null;
  trade?: Trade | null;
  rating: number;
  text: string;
  role: ReviewRole;
  isFlagged: boolean;
  isHidden: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export interface MerchantReview {
  id: string;
  amount: number;
  comment: string;
  type: ReviewType;
  createdAt: string;
  currency: string;
  currencySymbol: string;
  fiatAmount: number;
  helpful: boolean;
  reply: null | string;
  reviewer: {
    avatar?: null | string;
    id: string;
    username: string;
    role: null | string;
  };

  targetUser: {
    id: string;
    username: string;
    title: null | string;
    tradeType: TradeType;
  };
  verified: true;
}

export interface PaginationMeta {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export interface ReviewSummary {
  negativeReviews: number;
  positiveReviews: number;
  totalReviews: number;
}

export interface MerchantReviewInterface {
  data: MerchantReview[];
  summary: ReviewSummary;
  meta: PaginationMeta;
}
